<template>
  <div class="menu-management">
    <management-toolbar><el-button type="primary" icon="el-icon-plus" :disabled="savingMenu" @click="nuevoMenu">Añadir menú</el-button></management-toolbar>
    <p v-if="!data.length" class="management-empty">Todavía no hay menús. Crea el primero para elegir sus familias y platos.</p>
    <el-collapse accordion class="menu-list">
      <el-collapse-item v-for="menu in data" :key="menu.key" :name="menu.key">
        <template slot="title">
          <div class="menu-list-heading"><strong>{{ menu.name }}</strong><span v-if="menu.description">{{ menu.description }}</span><b>{{ menu.price }} €</b></div>
          <div class="menu-list-actions" @click.stop>
            <el-button icon="el-icon-arrow-up" :disabled="savingMenu || menu.key === 0" :aria-label="'Subir ' + menu.name" @click="moveUPMenu(menu)" />
            <el-button icon="el-icon-arrow-down" :disabled="savingMenu || menu.key === data.length - 1" :aria-label="'Bajar ' + menu.name" @click="moveDOWNMenu(menu)" />
            <el-switch v-model="menu.enable" :disabled="savingMenu" :aria-label="'Publicar ' + menu.name" @change="changeStatus" />
            <el-button icon="el-icon-edit" :disabled="savingMenu" :aria-label="'Editar ' + menu.name" @click="editMenu(menu)" />
            <el-button icon="el-icon-delete" :disabled="savingMenu" :aria-label="'Eliminar ' + menu.name" @click="menuSelected = menu.key; dialogDelete = true" />
          </div>
        </template>
        <section v-for="(family, index) in menu.groups" :key="family.key" class="menu-family-card">
          <header class="menu-family-heading"><h2><span>{{ index + 1 }}</span>{{ familyLabel(family.keyOriginal) }}</h2>
            <el-button size="small" icon="el-icon-edit" :disabled="savingMenu" @click="editArticles(menu.key, family.key, family.keyOriginal, family.plu)">Seleccionar y ordenar platos</el-button>
          </header>
          <ol v-if="family.plu.length" class="menu-dish-preview"><li v-for="key in family.plu" :key="key">{{ dishName(family.keyOriginal, key) }}</li></ol>
          <p v-else class="menu-dish-empty">Todavía no hay platos seleccionados en esta familia.</p>
        </section>
      </el-collapse-item>
    </el-collapse>

    <el-dialog v-for="mode in ['new', 'edit']" :key="mode" :title="mode === 'new' ? 'Nuevo menú' : 'Editar menú'"
      :visible="mode === 'new' ? dialogNewMenu : dialogEditMenu" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-position="top" class="menu-details-form" @submit.native.prevent>
        <el-form-item label="Nombre del menú" :for="'menu-name-' + mode"><el-input :id="'menu-name-' + mode" v-model="name" maxlength="20" show-word-limit placeholder="Nombre del menú" /></el-form-item>
        <el-form-item label="Precio (€)" :for="'menu-price-' + mode"><el-input :id="'menu-price-' + mode" v-model="price" placeholder="Precio del menú" /></el-form-item>
        <el-form-item label="Descripción" :for="'menu-description-' + mode" class="menu-description-field"><el-input :id="'menu-description-' + mode" v-model="description" type="textarea" :rows="2" placeholder="Descripción del menú" /></el-form-item>
        <tariff-prices v-if="mode === 'new' ? dialogNewMenu : dialogEditMenu" :key="mode+familyEditorSession" v-model="prices" />
      </el-form>
      <menu-dish-selector :key="mode + familyEditorSession" :value="mode === 'new' ? gruposSeleccionados : gruposEdit"
        @input="mode === 'new' ? gruposSeleccionados = $event : gruposEdit = $event"
        :dishes="selectableFamilies" available-title="Familias disponibles" selected-title="Orden de las familias"
        item-singular="familia" item-plural="familias" search-placeholder="Buscar familias"
        empty-available="Crea primero las familias en Platos menú."
        empty-selection="Selecciona las familias que quieres incluir en este menú." />
      <span slot="footer"><el-button :disabled="savingMenu" @click="mode === 'new' ? dialogNewMenu = false : dialogEditMenu = false">Cancelar</el-button>
        <el-button type="primary" :loading="savingMenu" @click="mode === 'new' ? newMenu() : saveEditMenu()">Guardar menú</el-button></span>
    </el-dialog>
    <el-dialog :title="dishDialogTitle" :visible.sync="dialogPLU" custom-class="menu-dishes-dialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <menu-dish-selector :key="dishEditorSession" v-model="pluSeleccionados" :dishes="familyDishes" />
      <span slot="footer"><el-button :disabled="savingMenu" @click="dialogPLU = false">Cancelar</el-button><el-button type="primary" :loading="savingMenu" @click="saveArticles">Guardar selección y orden</el-button></span>
    </el-dialog>
    <el-dialog title="Eliminar menú" :visible.sync="dialogDelete" :close-on-click-modal="false">
      <p>¿Quieres eliminar el menú «{{ data[menuSelected] ? data[menuSelected].name : '' }}»?</p>
      <span slot="footer"><el-button @click="dialogDelete = false">Cancelar</el-button><el-button type="danger" :loading="savingMenu" @click="deleteMenu">Eliminar menú</el-button></span>
    </el-dialog>
    <el-dialog title="Falta el nombre del menú" :visible.sync="notName" append-to-body><p>Indica un nombre antes de guardar.</p></el-dialog>
    <el-dialog title="Revisa el precio" :visible.sync="notPrice" append-to-body><p>Indica un precio válido igual o mayor que cero.</p></el-dialog>
  </div>
</template>
<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
import TariffPrices from '../components/TariffPrices.vue';
import MenuDishSelector from "../components/MenuDishSelector.vue";
import ManagementToolbar from "../components/ManagementToolbar.vue";
import { sortByName, reconcileMenuGroups } from "../utils/menuDishes";
export default {
  components: { MenuDishSelector, ManagementToolbar, TariffPrices },
  data() {
    return {
      savingMenu: false,
      pendingSave: false,
      dishEditorSession: 0,
      familyEditorSession: 0,
      name: "",
      price: "",
      prices: [],
      description: "",
      menuSelected: 0,
      keySelected: 0,
      keySelectedOriginal: 0,
      dialogNewMenu: false,
      dialogEditMenu: false,
      dialogDelete: false,
      dialogPLU: false,
      notName: false,
      notPrice: false,
      articleError: false,
      gruposSeleccionados: [],
      gruposEdit: [],
      pluBusqueda: [],
      pluSeleccionados: [],
      platosmenu: [],
      data: [],
      version: undefined,
    };
  },
  mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === false || this.authenticated === null) {
      this.$router.replace({ name: "login" });
    } else {
      this.loadData();
    }
  },
  computed: {
    selectableFamilies() { return this.platosmenu.map(group => ({ key: group.key, name: group.name, description: (group.plu || []).length + ((group.plu || []).length === 1 ? " plato disponible" : " platos disponibles") })); },
    sortedDishGroups() { return sortByName(this.platosmenu); },
    selectedFamily() { return this.platosmenu.find(group => group.key === this.keySelectedOriginal); },
    familyDishes() { return this.selectedFamily ? this.selectedFamily.plu : []; },
    dishDialogTitle() {
      const menu = this.data[this.menuSelected];
      return (menu ? menu.name + " · " : "") + (this.selectedFamily ? this.selectedFamily.name : "Platos del menú");
    },
    getData: function() {
      return this.data;
    },
    searchUser: function () {
      return this.pluBusqueda.filter((item) => item.name.includes(this.name));
    }
  },
  methods: {
    familyLabel(key) { const family = this.platosmenu.find(item => item.key === key); return family ? family.name : "Familia no disponible"; },
    dishName(groupKey, dishKey) {
      const group = this.platosmenu.find(item => item.key === groupKey);
      const dish = group && group.plu.find(item => item.key === dishKey);
      return dish ? dish.name : "Plato no disponible";
    },
    changeStatus: async function() {
      this.setData();
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadData: async function() {
      const snapshot = await api.getMenuCompleto();
      this.data = snapshot.menus;
      this.platosmenu = snapshot.grupos;
      this.pluBusqueda = snapshot.grupos;
      this.version = snapshot.version;
    },
    setData: async function() {
      if (this.savingMenu) {
        this.pendingSave = true;
        return false;
      }
      this.savingMenu = true;
      try {
        do {
          this.pendingSave = false;
          const result = await api.setMenu(JSON.parse(JSON.stringify(this.data)), this.version);
          this.version = result.version;
        } while (this.pendingSave);
        return true;
      } catch (error) {
        this.$message.error("No se han guardado los cambios. Recargando los datos.");
        this.dialogPLU = false;
        await this.loadData();
        return false;
      } finally {
        this.savingMenu = false;
        this.pendingSave = false;
      }
    },
    newMenu: async function() {
      if (this.savingMenu) return;
      if (!this.name.trim()) { this.notName = true; return; }
      const price = Number(this.price);
      if (!String(this.price).trim() || !Number.isFinite(price) || price < 0) { this.notPrice = true; return; }
      this.data.push({
        name: this.name.toUpperCase(), price: price.toFixed(2), prices:this.prices.map(p=>({...p})),
        key: this.data.length, description: this.description, enable: true,
        groups: reconcileMenuGroups([], this.gruposSeleccionados)
      });
      if (await this.setData()) this.dialogNewMenu = false;
    },
    moveUPMenu: function(menu) {
      if (menu.key > 0) {
        const index = menu.key;
        const other = index + (-1);
        const copy = this.data[index];
        this.$set(this.data, index, this.data[other]);
        this.$set(this.data, other, copy);
        this.data.forEach((item, key) => { item.key = key; });
        this.setData();
      }
    },
    moveDOWNMenu: function(menu) {
      if (menu.key < this.data.length - 1) {
        const index = menu.key;
        const other = index + (1);
        const copy = this.data[index];
        this.$set(this.data, index, this.data[other]);
        this.$set(this.data, other, copy);
        this.data.forEach((item, key) => { item.key = key; });
        this.setData();
      }
    },
    editArticles: function(menu, seccion, seccionOrig, plus) {
      this.menuSelected = menu;
      this.keySelected = seccion;
      this.keySelectedOriginal = seccionOrig;
      this.pluSeleccionados = plus.slice();
      this.dishEditorSession += 1;
      this.dialogPLU = true;
    },
    editMenu: function(menu) {
      this.name = menu.name;
      this.menuSelected = menu.key;
      this.price = menu.price;
      this.prices = (menu.prices || []).map(p=>({...p}));
      this.description = menu.description;
      this.gruposEdit = [];
      menu.groups.forEach((element) => {
        this.gruposEdit.push(element.keyOriginal);
      });
      console.log(this.gruposEdit);
      this.familyEditorSession += 1;
      this.dialogEditMenu = true;
    },
    saveArticles: async function() {
      if (this.savingMenu) return;
      const menu = this.data[this.menuSelected];
      const group = menu && menu.groups[this.keySelected];
      if (!group) return;
      group.plu = this.pluSeleccionados.slice();
      if (await this.setData()) this.dialogPLU = false;
    },
    saveEditMenu: async function() {
      if (this.savingMenu) return;
      if (!this.name.trim()) { this.notName = true; return; }
      const price = Number(this.price);
      if (!String(this.price).trim() || !Number.isFinite(price) || price < 0) { this.notPrice = true; return; }
      const menu = this.data[this.menuSelected];
      menu.name = this.name.toUpperCase();
      menu.price = price.toFixed(2);
      this.$set(menu,"prices",this.prices.map(p=>({...p})));
      menu.description = this.description;
      menu.groups = reconcileMenuGroups(menu.groups, this.gruposEdit);
      if (await this.setData()) this.dialogEditMenu = false;
    },
    deleteMenu: function() {
      this.data.splice(this.menuSelected, 1);
      var num = 0;
      this.data.forEach((element) => {
        element.key = num;
        num++;
      });
      this.dialogDelete = false;
      this.setData();
    },
    nuevoMenu: function() {
      this.name = "";
      this.price = "";
      this.prices = [];
      this.description = "";
      this.gruposSeleccionados = [];
      this.familyEditorSession += 1;
      this.dialogNewMenu = true;
    },
    moveUPGroupMenu: function(menu, item) {
      if (item.key > 0) {
        var copy = Object.assign({}, item);
        menu.groups[item.key].keyOriginal =
          menu.groups[item.key - 1].keyOriginal;
        menu.groups[item.key].plu = menu.groups[item.key - 1].plu;
        menu.groups[item.key - 1].keyOriginal = copy.keyOriginal;
        menu.groups[item.key - 1].plu = copy.plu;
      }
      this.setData();
    },
    moveDOWNGroupMenu: function(menu, item) {
      if (item.key < menu.groups.length - 1) {
        var copy = Object.assign({}, item);
        menu.groups[item.key].keyOriginal =
          menu.groups[item.key + 1].keyOriginal;
        menu.groups[item.key].plu = menu.groups[item.key + 1].plu;
        menu.groups[item.key + 1].keyOriginal = copy.keyOriginal;
        menu.groups[item.key + 1].plu = copy.plu;
      }
      this.setData();
    },
  },
};
</script>

<style scoped>
.menu-list { margin-top: 20px; }
.menu-list > .el-collapse-item { margin-bottom: 16px; background: white; border: 1px solid #dce4e3; border-radius: 14px; overflow: hidden; }
.menu-list-heading { display: grid; flex: 1; grid-template-columns: minmax(0, 1fr) 90px; align-items: center; gap: 4px 16px; min-width: 0; }
.menu-list-heading strong { font-size: 18px; overflow-wrap: anywhere; }
.menu-list-heading span { color: #687780; font-size: 13px; font-weight: 400; grid-column: 1; grid-row: 2; overflow-wrap: anywhere; }
.menu-list-heading b { white-space: nowrap; font-size: 16px; grid-column: 2; grid-row: 1 / 3; text-align: right; margin-right: 16px; }
.menu-list-actions { display: flex; align-items: center; gap: 6px; margin-right: 12px; }
.menu-list-actions .el-button { padding: 8px; margin: 0; }
.menu-family-card { margin-top: 16px; border: 1px solid #e0e6e4; border-radius: 10px; overflow: hidden; }
.menu-family-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; background: #edf2f0; padding: 14px 16px; }
.menu-family-heading h2 { margin: 0; display: flex; align-items: center; gap: 10px; font-size: 17px; }
.menu-family-heading h2 span { display: inline-flex; align-items: center; justify-content: center; width: 26px; height: 26px; border-radius: 50%; background: #526f60; color: white; font-size: 12px; }
.menu-dish-preview { padding: 8px 16px 8px 40px; margin: 0; font-size: 14px; line-height: 1.7; }
.menu-dish-preview li { padding: 8px 0; border-bottom: 1px solid #edf1ef; }
.menu-dish-preview li:last-child { border: 0; }
.menu-dish-empty, .management-empty { padding: 16px; color: #687780; font-size: 14px; }
.menu-details-form { display: grid; grid-template-columns: 2fr 1fr; gap: 0 20px; }
.menu-description-field { grid-column: 1 / -1; }
@media(max-width:760px) { .menu-list-actions { flex-wrap: wrap; } .menu-list ::v-deep .el-collapse-item__header { flex-wrap: wrap; gap: 12px; } .menu-list-heading { flex-basis: 100%; } .menu-details-form { grid-template-columns: 1fr; } }
</style>
